module.exports = __webpack_public_path__ + "img/logo.c998a0b8.png";